const t = {
  LEFT: "left",
  RIGHT: "right"
}, O = ["sm", "md", "lg", null], o = {
  ROOT_LAYOUT_SIDEBAR_POSITIONS: t,
  ROOT_LAYOUT_RESPONSIVE_BREAKPOINTS: O
};
export {
  O as ROOT_LAYOUT_RESPONSIVE_BREAKPOINTS,
  t as ROOT_LAYOUT_SIDEBAR_POSITIONS,
  o as default
};
//# sourceMappingURL=root-layout-constants.js.map
